<template>
  <div>
    <div class="position-relative">
      <span class="product-inscription">{{inscription}}</span>
    </div>
    <div data-aos="fade-up">
      <video
        class="product-video"
        width="auto"
        playsinline
        loop
        muted
        autoplay
        :title="name +' ruchoma grafika'"
      >
        <source :src="video" type="video/mp4" />Your browser does not support the video tag.
      </video>
    </div>
    <img :src="image1" :alt="name+' w pudełku'" data-aos="fade-up" />
    <img :src="image2" :alt="name+' w torebkach'" data-aos="fade-up" />
  </div>
</template>

<script>
export default {
  props: ["name", "inscription", "video", "image1", "image2"]
};
</script>
<style  lang="scss" scoped>
.product-inscription {
  font-weight: bold;
  font-size: 3.4rem;
  letter-spacing: 10px;
  transform: rotate(270deg) translateZ(20px);
  position: absolute;
  left: -70px;
  top: 200px;
  width: 300px;
  text-align: right;
  z-index: 2;
  @media (max-width: 768px) {
    font-size: 2rem;
    left: -120px;
    top:200px;
  }
}
video.product-video {
  width: calc(100% + 2px);
  height: auto;
  margin-bottom: -4px !important;
  margin-left:-1px;
  @media (max-width: 768px) {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/small-components/JanczakiProductComponent.vue